export const URLS = {
  monitoring: {
    public: {
      safeGptEvent: {
        detail: (eventId: string) => `public/safe-gpt/${eventId}/`,
        timeline: (eventId: string) => `public/safe-gpt/${eventId}/timeline/`,
      },
    },
  },
  core: {
    gpt: {
      alarm: {
        types: 'gpt/alarm/types/',
      },
    },
  },
};
